<app-page>
    <app-title>
        {{ 'requirements' | translate }}
    </app-title>
    <br>
    <div align="center">
        <span class="bold-text">
            1. {{ 'requirement_tablet' | translate}}
        </span>
        <a href="https://play.google.com/store/apps/details?id=com.waiternow.business&hl=en_US&gl=US&pli=1" target="_blank">
            ({{ 'link' | translate}})
        </a>
        <br>
        {{ 'requirement_tablet_android_version' | translate }}
        <br>
        <strong>{{ 'requirement_tablet_recommendation' | translate }}</strong>
        <a href="https://www.amazon.com/SAMSUNG-Android-Compact-Lasting-Battery/dp/B094Q89NKH/ref=sr_1_3?keywords=Samsung+galaxy+tab+a7+lite+8.7%27%27&qid=1688147565&sr=8-3" target="_blank">
            ({{ 'link' | translate}})
        </a>
    </div>
    <br>
    <div align="center">
        <span class="bold-text">
            2. {{ 'requirement_printer' | translate}}
        </span>
        <br>
        <a href="https://star-emea.com/products/sp700/" target="_blank">
            Star Micronics SP 700 LAN
        </a>
        <a href="https://www.amazon.com/Star-Micronics-Ethernet-Auto-cutter-Internal/dp/B01DVEOLFG" target="_blank">
            (Amazon)
        </a>
        <br>
        <a href="https://star-emea.com/products/tsp100iv/" target="_blank">
            Star Micronics TSP100IV LAN
        </a>
        <a href="https://www.amazon.com/Micronics-TSP143IVUW-Direct-Thermal-Printer/dp/B0BG99F4R9" target="_blank">
            (Amazon)
        </a>
        <br>
        <a href="https://star-emea.com/products/tsp100/" target="_blank">
            Star Micronics TSP100III LAN
        </a>
        <a href="https://www.amazon.com/Star-Micronics-TSP143IIILAN-Ethernet-Auto-cutter/dp/B01HRJRXZQ" target="_blank">
            (Amazon)
        </a>
        <strong>(Preferred)</strong>
        <br>
        <a href="https://star-emea.com/products/tsp100/" target="_blank">
            Star Micronics TSP100IIIW Wi-Fi
        </a>
        <a href="https://www.amazon.com/Star-Micronics-TSP143IIIW-Wireless-Internal/dp/B01BJOFPNM" target="_blank">
            (Amazon)
        </a>
    </div>
    <br>
    <div align="center">
        <span class="bold-text">
            3. {{ 'requirement_ethernet_adapter' | translate}}
        </span>
        <br>
        {{ 'requirement_ethernet_adapter_line_1' | translate }}
        <a href="https://www.amazon.com/dp/B0118SPFCK/?_encoding=UTF8&pd_rd_i=B0118SPFCK&ref_=sbx_be_s_sparkle_ssd_tt&qid=1741560461&pd_rd_w=1NHme&content-id=amzn1.sym.8591358d-1345-4efd-9d50-5bd4e69cd942%3Aamzn1.sym.8591358d-1345-4efd-9d50-5bd4e69cd942&pf_rd_p=8591358d-1345-4efd-9d50-5bd4e69cd942&pf_rd_r=CQGYC9NRN5KZ0RYC2R73&pd_rd_wg=YRqbQ&pd_rd_r=edee0af6-2908-424f-86ca-7e30d7f2ee98&pd_rd_plhdr=t" target="_blank">
            (Amazon)
        </a>
        <br>
        {{ 'requirement_ethernet_adapter_line_2' | translate }}
        <br>
        {{ 'requirement_ethernet_adapter_line_3' | translate }}
    </div>
    <br>
    <div align="center" class="equipment_lending-text palette-color-red">
        {{ 'equipment_lending' | translate}}
    </div>
</app-page>
